// paywal-page页面变化相关逻辑配置项
const paypalPageConfig = {
        fitnessLevelLableName: "fitnessLevel",
        leveName: 'pilatesLevel',
        fitnessLevelOptionName: "yogaLevelScreenOption",
};
export default paypalPageConfig